import * as React from "react";
import styled, { css } from "styled-components";
import usePluginEntities from "hooks/usePluginEntities";
import useLocation from "routing/useLocation";
import zIndices from "theme/z-indices";
import NavItem from "./NavItem";
export const Container = styled.div(
  ({ $isOpen, $sidebarIsPinned, theme }) => css`
    background: ${theme.colors.global.navigationBackground};
    color: ${theme.utils.contrastingColor(theme.colors.global.navigationBackground, "AA")};
    box-shadow: ${$sidebarIsPinned && $isOpen ? "none" : `3px 3px 3px ${theme.colors.global.navigationBoxShadow}`};
    width: 50px;
    height: 100%;
    position: relative;
    z-index: ${zIndices.sidebarContentColumn};

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: -6px;
      height: 6px;
      width: 6px;
      border-top-left-radius: 50%;
      background: transparent;
      box-shadow: -6px -6px 0 3px ${theme.colors.global.navigationBackground};
    }
  `
);
export const Section = styled.div`
  > * {
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
const HorizontalRuleWrapper = styled.div`
  padding: 0 10px;

  hr {
    border-color: currentColor;
    margin: 5px 0 10px;
  }
`;
const SidebarNavigation = ({ sections, activeSection, selectSidebarSection, sidebarIsPinned, actions }) => {
  const activeSectionKey = activeSection == null ? void 0 : activeSection.key;
  const { pathname } = useLocation();
  const links = usePluginEntities("views.searchDataSources");
  const accessibleLinks = links.filter((link) => link.useCondition ? !!link.useCondition() : true);
  return /* @__PURE__ */ React.createElement(Container, { $sidebarIsPinned: sidebarIsPinned, $isOpen: !!activeSection }, (accessibleLinks == null ? void 0 : accessibleLinks.length) > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Section, null, accessibleLinks.map(({ icon, title, link, key }) => /* @__PURE__ */ React.createElement(
    NavItem,
    {
      isSelected: link === pathname,
      ariaLabel: `Open ${title}`,
      icon,
      key,
      linkTarget: link,
      title
    }
  ))), /* @__PURE__ */ React.createElement(HorizontalRuleWrapper, null, /* @__PURE__ */ React.createElement("hr", null))), /* @__PURE__ */ React.createElement(Section, null, sections.map(({ key, icon, title: sectionTitle, hoverTitle }) => {
    const isSelected = activeSectionKey === key;
    const title = hoverTitle != null ? hoverTitle : sectionTitle;
    return /* @__PURE__ */ React.createElement(
      NavItem,
      {
        isSelected,
        ariaLabel: isSelected ? `Close ${title} section` : `Open ${title} section`,
        icon,
        onClick: () => selectSidebarSection(key),
        key,
        title,
        sidebarIsPinned
      }
    );
  })), (actions == null ? void 0 : actions.length) > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HorizontalRuleWrapper, null, /* @__PURE__ */ React.createElement("hr", null)), /* @__PURE__ */ React.createElement(Section, null, actions.map(({ key, Component }) => /* @__PURE__ */ React.createElement(Component, { key, sidebarIsPinned })))));
};
export default SidebarNavigation;
